import { render } from "./AddExaminationGuide.vue?vue&type=template&id=dc5d2312&scoped=true"
import script from "./AddExaminationGuide.vue?vue&type=script&lang=js"
export * from "./AddExaminationGuide.vue?vue&type=script&lang=js"

import "./AddExaminationGuide.vue?vue&type=style&index=0&id=dc5d2312&scoped=true&lang=css"

import exportComponent from "D:\\newProjectGit\\HbzsbAdminClient\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-dc5d2312"]])

export default __exports__